<h2 mat-dialog-title>Attenzione: conferma dati</h2>

    <mat-dialog-content>
      <p>Il cliente selezionato per questa fattura ha alcuni campi non valorizzati:</p>
      <p><strong>Partita IVA:</strong> {{ iva_number }}</p>
      <p><strong>Codice Fiscale:</strong> {{ c_f }}</p>
      <p>Ricorda che <u>almeno uno</u> dei due campi deve essere presente. Puoi proseguire lo stesso, ma considera che dati mancanti (come la Partita Iva assente) potrebbero causare errori durante l'invio. Confermi che il cliente è corretto?</p>
      <mat-checkbox [(ngModel)]="confirmed">Sì, i dati sono corretti.</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Torna indietro e modifica</button>
      <button mat-raised-button color="primary" [disabled]="!confirmed" (click)="confirm()">
        <mat-icon>check</mat-icon>
        Prosegui
      </button>
    </mat-dialog-actions>
